// extracted by mini-css-extract-plugin
export var resultEntry = "SearchGooglishWidget-module--resultEntry--2f792";
export var resultEntryLink = "SearchGooglishWidget-module--resultEntryLink--89749";
export var resultEntryList = "SearchGooglishWidget-module--resultEntryList--bc8da";
export var resultEntrySynopsis = "SearchGooglishWidget-module--resultEntrySynopsis--1039f";
export var resultEntryTitle = "SearchGooglishWidget-module--resultEntryTitle--fcf4d";
export var results = "SearchGooglishWidget-module--results--914c0";
export var resultsSeparator = "SearchGooglishWidget-module--resultsSeparator--3b8cd";
export var searchField = "SearchGooglishWidget-module--searchField--a8f64";
export var spinnerActive = "SearchGooglishWidget-module--spinnerActive--c245e";
export var spinnerInactive = "SearchGooglishWidget-module--spinnerInactive--1328a";
export var toggle = "SearchGooglishWidget-module--toggle--04526";
export var widget = "SearchGooglishWidget-module--widget--03df1";
export var widgetInput = "SearchGooglishWidget-module--widgetInput--5b08c";
export var wrapper = "SearchGooglishWidget-module--wrapper--cb4cc";